import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Forms.css";

const LoginForm = ({ login }) => {
  const navigate = useNavigate();

  const INITIAL_STATE = { username: "", password: "" };
  const [formData, setFormData] = useState(INITIAL_STATE);
  const [error, setError] = useState(null);
  const [loggedIn, setLoggedIn] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { username, password } = formData;
      const loginSuccess = await login(username, password);
      setFormData(INITIAL_STATE);
      if (loginSuccess) {
        navigate("/spaces");
        setError(null);
        setLoggedIn(true);
      } else {
        setError("Invalid credentials. Please try again.");
      }
    } catch (error) {
      console.error("Login failed:", error);
      setError("Invalid credentials. Please try again.");
    }
  };

  return (
    <div className="form-page">
      <div className="form-card">
        {loggedIn ? (
          <p className="form-success">Login successful. Redirecting...</p>
        ) : (
          <>
            <h1 className="form-card-title">Sign In</h1>
            <p className="form-card-subtitle">Welcome back to Bells+Whistles</p>

            <form onSubmit={handleSubmit}>
              <div className="form-field">
                <label className="form-label" htmlFor="username">Username</label>
                <input
                  id="username"
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                />
              </div>

              <div className="form-field">
                <label className="form-label" htmlFor="password">Password</label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              {error && <p className="form-error">{error}</p>}

              <button className="form-submit-btn" type="submit">Sign In</button>
            </form>

            <p className="form-footer-text">
              Don't have an account? <Link to="/signup">Get started</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginForm;
